<template lang="pug">
div
  button.change-button(
    :disabled="disabled || loading"
    @click="confirm"
    data-testid="action-btn-quitar-prioridad-asignacion"
  )
    b-spinner(v-if="loading" small)
    span(v-else) Quitar prioridad de asignación
</template>

<script>
import { mapActions } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'

export default {
  name: 'ActionQuitarPrioridadAsignacion',
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled'],
  methods: {
    ...mapActions('OTStore', ['quitarPrioridadAsignacion', 'getOT']),
    async confirm() {
      try {
        const confirmed = await this.$bvModal.msgBoxConfirm(
          'La OT dejará de ser prioritaria y volverá a su lugar normal en la cola de asignación. ¿Continuar?',
          {
            title: 'Por favor Confirma',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'primary',
            okTitle: 'SÍ',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          }
        )
        if (!confirmed) return
        await this.executeWithLoading(async () => {
          await this.quitarPrioridadAsignacion({ otId: this.ot.ot })
          this.$bvToast.toast('Se quitó la prioridad de asignación.', {
            variant: 'success',
          })
          await this.getOT(this.ot.ot)
          this.$emit('changed')
        })
      } catch (error) {
        console.error('Error al quitar prioridad de asignación:', error)
        this.$bvToast.toast('Error al quitar prioridad de asignación.', {
          variant: 'danger',
        })
      }
    },
  },
}
</script>
